import axios from 'axios';

export default {
  downloadReport(_, params) {
    const { startDate, endDate } = params;
    const text = encodeURIComponent(params.text ? params.text : '');

    return axios.get(`/activityReport?startDate=${startDate}&endDate=${endDate}&text=${text}`, {
      responseType: 'blob',
      timeout: 30000,
    });
  },
};
